// utils
import React from "react";
import { useMatch } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

// custom utils
import { getCurrentLanguage, getUrlPrefix, LANGUAGES } from "../../../../utils/langUtils";

// translations
import translation_cs from "./lang/cs.json";
import translation_en from "./lang/en.json";
import translation_de from "./lang/de.json";

// files
import BtnBgPlum70Dialog from "../../../../components/btn/btn-bg-plum-70-dialog";

/**
 * CybersecOpenCalc section
 * small banner with button to open calculator page
 * TODO: Multiple calculators? - make this reusable or find different way to do show this
 * @returns HTML code with CybersecOpenCalc section for CYBERSEC page
 */
export default function CybersecOpenCalc() {
    
    const match = useMatch("/:lang/*");
    let lang = (match && match.params.lang) ? match.params.lang : "";

    let translation = translation_cs;

    let language = getCurrentLanguage(lang);
    switch (language) {
        case LANGUAGES.Czech:
            translation = translation_cs;
            break;
        case LANGUAGES.English:
            translation = translation_en;
            break;
        case LANGUAGES.German:
            translation = translation_de;
            break;
    }
    
    // solves broken layout of some pages in build
    const [hasMounted, setHasMounted] = React.useState(false);
    React.useEffect(() => {
      setHasMounted(true);
    }, []);
    if (!hasMounted) {
      return null;
    }

    return (
        <>
          <div className="py-2 py-md-5">
            <Container fluid={"lg"}>
              <Row>
                <Col xs={12} sm={12} md={8} className="my-auto">
                  <h4 className="font-divelit-plum">
                    {translation.title1}

                  </h4>
                  <span className="paragraph-medium">
                    {translation.title2}
                  </span>
                </Col>
                <Col xs={12} sm={12} md={4} className="d-flex align-items-center justify-content-center mt-2 mt-md-0">
                  <BtnBgPlum70Dialog
                    redirectTo={getUrlPrefix(language) + "calculator/en18031"}
                    buttonText={translation.button}
                  ></BtnBgPlum70Dialog>
                </Col>
              </Row>
            </Container>
          </div>
        </>
    );
}
